import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetOpenId({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Share/GetOpenId',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetJssdkConfig({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Share/GetJssdkConfig',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },

}

const mutations = {
    
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/share.js